export default __webpack_public_path__ + "static/media/all-sto.2a9ea808.svg";